// extracted by mini-css-extract-plugin
var _1 = "LoadingSection_AnimateBG__sX6ZD";
var _2 = "LoadingSection_loadingSection__XYX5m";
export { _1 as "AnimateBG", _2 as "loadingSection" }
